export default __webpack_public_path__ + "4fa40d277c8fb715111f751a854a20f3.svg";